import { forwardRef } from "react";
import { TextBox } from "@etframework/ui.components";

export const StageNameTextBox = forwardRef(
  ({ name, nameLabel, stageName, change, id }, ref) => {
    return (
      <TextBox
        ref={ref}
        name={name}
        id={id}
        value={stageName}
        type="text"
        showClearButton
        labelText={nameLabel}
        change={(e) => {
          ref.current.setShowError(false);
          change(e);
        }}
      ></TextBox>
    );
  }
);
